import { render, staticRenderFns } from "./tabMutasi.vue?vue&type=template&id=f635c906"
import script from "./tabMutasi.vue?vue&type=script&lang=js"
export * from "./tabMutasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports